/**
 * Channel Service
 * Handles channel-related API calls
 */

import api from '@/lib/api';
import { API_ENDPOINTS } from '@/constants/endpoints';
import { ChannelAdapter } from '@/adapters';
import type {
  ApiResponse,
  Channel,
  UpdateChannelDto,
  ChannelResponseDto,
  ChannelsListResponseDto
} from '@/types';

export const channelService = {
  /**
   * Get all channels
   */
  async getChannels(params?: { bu_id?: string }): Promise<Channel[]> {
    const response = await api.get<ApiResponse<ChannelsListResponseDto>>(API_ENDPOINTS.CHANNELS.BASE, { params });
    return ChannelAdapter.fromApiList(response.data.data.channels);
  },

  /**
   * Get default channels
   */
  async getDefaultChannels(params?: { bu_id?: string }): Promise<Channel[]> {
    const response = await api.get<ApiResponse<ChannelsListResponseDto>>(API_ENDPOINTS.CHANNELS.DEFAULT, { params });
    return ChannelAdapter.fromApiList(response.data.data.channels);
  },

  /**
   * Update channel
   */
  async updateChannel(id: string, data: UpdateChannelDto): Promise<Channel> {
    const payload = ChannelAdapter.toUpdateRequest(data);
    const response = await api.put<ApiResponse<ChannelResponseDto>>(API_ENDPOINTS.CHANNELS.BY_ID(id), payload);
    return ChannelAdapter.fromApi(response.data.data);
  },
};
